module.exports = __webpack_public_path__ + "img/dt.b9abb8c0.jpg";